<template>
    <b-modal id="support-modal" centered no-close-on-backdrop scrollable :footer-class="'d-block p-3 m-0'"
        :body-class="'equipment-edit-modal'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('support.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body mt-3">
            <div class="row" v-if="user">
                <b-col sm="12">
                    <b-form-group :label="$t('support.nameLabel')" class="text-left mb-3">
                        <b-form-input type="text" :placeholder="$t('support.namePlaceholder')" disabled class="unit"
                            v-model="name"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('support.emailLabel')" class="text-left mb-3">
                        <b-form-input type="email" :placeholder="$t('support.emailPlaceholder')" class="unit" v-model="user.email"
                            required></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('support.messageLabel')" class="text-left mb-3 ">
                        <b-form-textarea rows="5" class="resize-none" v-model="message"></b-form-textarea>
                        <p v-if="errors && errors.message" class="field-error mt-2">
                            {{ errors.message[0] }}
                        </p>
                    </b-form-group>
                </b-col>
            </div>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0">
                <b-button class="mt-3 mr-3 btn cancel mb-0 m-0" variant="secondary" v-if="!expiry"
                    @click="resetForm">{{ $t('support.cancel') }}</b-button>
                <b-button class="mt-3 btn save mx-0 mb-0 m-0" variant="primary" @click="handleFormSubmit">{{ $t('support.send') }}</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { clearGleapUser } from "@/plugins/gleap";
export default {
    name: "Support",
    props: {
        expiry: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            message: "",
            errors: {}
        }
    },
    computed: {
        ...mapGetters(["user"]),
        name() {
            return this.user.first_name + " " + this.user.last_name
        }
    },
    methods: {
        ...mapActions(['contactUs', 'setNotification', 'logoutUser', 'createUserLogs']),
        resetForm() {
            this.message = ''
            this.errors = {}
            this.$emit("close")
            this.$bvModal.hide('support-modal')
        },
        async logout() {
            await this.createUserLogs({ action: 'logout' });
            this.logoutUser();
            if(!process.env.VUE_APP_SHOW_INTERCOM) {
            clearGleapUser();
            }
            this.$router.push("/login");
        },
        async handleFormSubmit() {
            if (this.message) {
                try {
                    await this.contactUs({
                        name: this.name,
                        email: this.user.email,
                        message: this.message
                    })
                    await this.setNotification({
                        msg: this.$t('support.messageSent'),
                        type: "success",
                        color: "green",
                    });
                    this.errors = {}
                    if(this.expiry) this.$router.push("/all-companies")
                    this.resetForm()
                }
                catch (e) {
                    console.log(e)
                }
            }
            else this.errors = {
                message: [this.$t('support.fieldRequired')]
            }
        }
    },
}
</script>